module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av700-47a4df3753dbaffdcc2d160a2263ac95.jpg";